import FeaturedBanner from "@components/About/Banner/FeaturedBanner";
import BannerFooter from "@components/About/BannerFooter";
import CoreValues from "@components/About/CoreValues";
import FeaturedAbout from "@components/About/FeaturedAbout";
import Banner from "@components/Banner";
import Breadcrumbs from "@components/Breadcrumbs";
import Footer from "@components/Footer";
import Header from "@components/Header";
import { usePageContext } from "@providers/PageProvider";
import { useRouteContext } from "@providers/RouteProvider";
import helper, { aboutUsPage } from "@utils/helper";
import _ from "lodash";

const View = () => {
  const { router } = useRouteContext();
  const { pageData } = usePageContext();
  const banner = helper.formatBanner(pageData);
  const bannerFooter = aboutUsPage.formatBannerFooter(pageData);
  return (
    <div className="" data-scroll-container>
      <Header />
      <Banner
        image={_.get(banner, "image")}
        scale={1.1}
        title={_.get(banner, "title", "")}
      />
      <Breadcrumbs data={router.breadcrumbs("about-us", {})} />
      <FeaturedBanner />
      <FeaturedAbout />
      <CoreValues />
      <BannerFooter image={bannerFooter ?? { src: "", alt: "" }} />
      <Footer hideSocialIcons />
    </div>
  );
};

export default View;
